/* global wpApiSettings */

import VanillaModal from 'vanilla-modal';
import autosize from 'autosize';

let $component;
let itemType;

let $form;
// let $fileInput;
// let $initialData;
let currentYoutubeId;
let youtubeDebounce;

function init($el) {

	$form = $el;

	const $fileInput = $form.find('.image-upload__file');

	if (!$fileInput) {
		return;
	}

	itemType = $form.data('item-type');

	$component = $form.find('.image-upload');

	$fileInput.on('change', handleFileInputChange);
	$form.find('[name="image-upload-list-mode"]').on('change', toggleEditmode);

	registerFileListActions();

	try {

		const initialData = JSON.parse($form.find('.image-upload__data').html());

		initialData.forEach((response) => {

			addItem(response);

		});

	} catch (error) { /* ... */ }

	if (document.querySelector('[rel="youtube-modal:open"]') && document.querySelector('#youtube-modal')) {

		const youtubeModal = new VanillaModal({
			modal: '.modal',
			modalInner: '.modal-inner',
			modalContent: '.modal-content',
			onOpen: function() {
				const headerEl = this.dom.modalInner.querySelector('.modal-header');
				const titleEl = headerEl.querySelector('h4');
				const title = this.current.getAttribute('data-title');
				titleEl.textContent = title;
			},
			onClose: function() {
				$(this.current).find('input').val('');
				$(this.current).find('.image-upload__youtube-adder-preview').empty('');
			},
			open: '[rel="youtube-modal:open"]'
		});

		const $youtubeAddress = $component.find('.image-upload__youtube-adder input');

		$youtubeAddress.on('keyup blur', (event) => {
			updateYoutubeField(event.target);
		});

		$component.find('.image-upload__youtube-adder-footer button').on('click', (event) => {
			const itemData = {
				youtube_id: currentYoutubeId
			};
			addItem(itemData);
		});

	}


}

/**
 * Get YouTube ID from various YouTube URLs
 * @author takien
 * @url: http://takien.com
 * @link https://gist.github.com/takien/4077195
 */

function getYoutubeId(url) {

	const urlParts = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
	let id = '';

	if (urlParts[2] !== undefined) {
		id = urlParts[2].split(/[^0-9a-z_-]/i);
		id = id[0];
	} else {
		id = urlParts;
	}

	return id;
}



function updateYoutubeField(inputEl) {

	const youtubeId = getYoutubeId(inputEl.value);

	window.clearTimeout(youtubeDebounce);

	if (youtubeId && youtubeId !== currentYoutubeId) {

		currentYoutubeId = youtubeId;

		youtubeDebounce = window.setTimeout(() => {
			$('.image-upload__youtube-adder-preview')
			.empty()
			.append(`<iframe width="1280" height="720" src="https://www.youtube.com/embed/${youtubeId}?rel=0" frameborder="0" allowfullscreen></iframe>`);
		}, 500);

	}

}


/**
 * Handle file input change
 *
 * @link https://developer.mozilla.org/en/docs/Using_files_from_web_applications
 * @link https://css-tricks.com/drag-and-drop-file-uploading/
 * @link https://www.html5rocks.com/en/tutorials/file/dndfiles/
 */

function handleFileInputChange(event) {

	const $form = $(event.target).closest('form');
	const $fileInput = $form.find('.image-upload__file');

	const files = Array.from(event.target.files);
	const fileUploads = files.map((file) => uploadFile($form, file));
	const $listPlaceholders = files.map((file, index) => $(renderPlaceholder(file, index)));

	$('.image-upload__list').append($listPlaceholders);

	fileUploads.forEach((promise, index) => {

		promise.then((response) => {

			addItem(response, index);

		});

	});

	Promise.all(fileUploads).then((responses) => {

		/**
		 * Clear file input
		 * TODO: Remove the fallback if IE10 compatibility is ever dropped.
		 * @link http://stackoverflow.com/questions/1703228/how-can-i-clear-an-html-file-input-with-javascript/16222877#16222877
		 */

		(function(fileInputEl) {
			try {
				fileInputEl.value = null;
			} catch (error) {
				// Fallback for IE10
				fileInputEl.parentNode.replaceChild(fileInputEl.cloneNode(true), fileInputEl);
			}
		}($fileInput.get(0)));

	});

}


function addItem(itemData, index) {

	const $item = $(renderItem(itemData));
	const $textarea = $item.find('textarea');

	if (typeof index !== 'undefined') {
		$(`#image-upload__item-placeholder--${index}`).parent().replaceWith($item);
	} else {
		$('.image-upload__list').append($item);
	}

	updateItemIndexes();

	window.setTimeout(() => {

		autosize($textarea);

		$textarea.textcounter({
			max: $textarea.data('limit'),
			counterText: `Tekstin pituus: %d / ${$textarea.data('limit')}`
		});

	}, 100);

}

/*
 * Render markup for a placeholder item
 */

function renderPlaceholder(file, index) {

	return `
		<li>
			<div class="image-upload__item-placeholder" id="image-upload__item-placeholder--${index}">
				<div class="image-upload__item-placeholder-loader">
					<div class="loader">Lataa...</div>
				</div>
				<p><strong>Lähetetään tiedostoa:</strong> ${file.name}</p>
			</div>
		</li>
	`.trim();

}

/*
 * Render markup for an actual item (ACF repeater item)
 */

function renderItem(item) {

	const img_id = item.image_id || item.id;
	const img_src = item.image_src || (item.media_details && item.media_details.sizes['place-slip-image'].source_url);
	const imageField = (itemType === 'story') ? 'fields[story__album][%i][image]' : 'fields[place__image]';
	// const mediaType = img_id ? 'image' : 'video';

	const image_markup = img_id ? `
		<img src="${img_src}" alt="" />
		<input type="hidden" data-name="${imageField}" name="${imageField}" value="${img_id}" />
		<input type="hidden" name="fields[story__album][%i][youtube_id]" data-name="fields[story__album][%i][youtube_id]" value="" />
	` : '';

	const video_markup = !img_src && item.youtube_id ? `
		<img src="/wp-content/themes/kylahistoria/dist/assets/images/youtube-placeholder.png" alt="" width="100" height="100" class="image-upload__item-media-placeholder placeholder--video" />
		<input type="hidden" name="${imageField}" data-name="${imageField}" value="" />
		<input type="hidden" name="fields[story__album][%i][youtube_id]" data-name="fields[story__album][%i][youtube_id]" value="${item.youtube_id}" />
	` : '';

	const video_title = !img_src && item.youtube_id ? `
		<p><a href="https://www.youtube.com/watch?v=${item.youtube_id}" target="_blank">https://www.youtube.com/watch?v=${item.youtube_id}</a></p>
	` : '';

	return `
		<li>
			<div class="image-upload__item">
				<div class="image-upload__item-wrap">
					<div class="image-upload__item-media">
						${img_src ? image_markup : video_markup}
					</div>
					<div class="image-upload__item-copy">
						${video_title}
						<textarea data-name="fields[story__album][%i][caption]" class="form__control" data-limit="1000">${typeof item.caption === 'string' ? item.caption : ''}</textarea>
					</div>
					<div class="image-upload__item-controls">
						<button type="button" class="image-upload__control control--delete button theme--primary" data-action="delete">Poista</button><br />
						<button type="button" class="image-upload__control control--move-up button theme--default" data-action="move-up">Siirrä ylöspäin</button><br />
						<button type="button" class="image-upload__control control--move-down button theme--default" data-action="move-down">Siirrä alaspäin</button>
					</div>
				</div>
			</div>
		</li>
	`.trim();

}

function updateItemIndexes() {

	$component.find('.image-upload__list li').each((outerIndex, itemEl) => {
		$(itemEl).find('input, textarea').each((innerIndex, inputEl) => {
			$(inputEl).attr('name', $(inputEl).attr('data-name').replace('%i', outerIndex));
		});
	});

}


/*
 * Handle file upload
 */

function uploadFile($form, file) {

	const fileData = new FormData();

	fileData.append('file', file);

	const promise = new Promise((resolve, reject) => {

		$.ajax({
			method: 'POST',
			url: '/wp-json/wp/v2/media/',
			data: fileData,
			contentType: false,
			processData: false,
			beforeSend: (xhr) => {
				// xhr.setRequestHeader('X-WP-Nonce', $form.find('[name="_wpnonce"]').val());
				// xhr.setRequestHeader('Content-Disposition', `filename=${file.name}`);
				xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
			},
			success: (response) => {
				resolve(response);
			},
			fail: (response) => {
				reject(response);
			}
		});

	});

	return promise;

}

/*
 * Register file list event listeners
 */

function registerFileListActions() {

	const $list = $('.image-upload__list');

	$list.on('click', 'button[data-action="delete"]', (event) => {
		$(event.target).closest('li').remove();
		updateItemIndexes();
	});

	$list.on('click', 'button[data-action="move-up"]', (event) => {
		const $listItem = $(event.target).closest('li');
		$listItem.insertBefore($listItem.prev());
		updateItemIndexes();
	});

	$list.on('click', 'button[data-action="move-down"]', (event) => {
		const $listItem = $(event.target).closest('li');
		$listItem.insertAfter($listItem.next());
		updateItemIndexes();
	});

}


/*
 * Toggle edit mode between editing texts and sorting/deleting
 */

function toggleEditmode(event) {

	$form.find('[name="image-upload-list-mode"]').find('.button').removeClass('active');
	$form.find('[name="image-upload-list-mode"][value="' + event.target.value + '"]').find('.button').addClass('active');

	$component[0].classList.toggle('editmode--controls', (event.target.value === 'controls'));

}


// function createThumbnail(file) {
//
// 	if (!file.type.match(/^image\//)) {
// 		return;
// 	}
//
// 	const img = document.createElement('img');
//
// 	img.file = file;
//
// 	const reader = new FileReader();
// 	const promise = new Promise((resolve, reject) => {
//
// 		reader.onload = (function(theImg) {
// 			return function(event) {
// 				theImg.src = event.target.result;
// 				resolve(img);
// 			};
// 		}(img));
//
// 		reader.readAsDataURL(file);
// 	});
//
//
// 	return promise;
//
// }


export default {
	init
};
